import { Typography } from '@design-system/typography';
import React, { FC } from 'react';

import { HeadlineProps } from './models';
import { setHeadlineTitle } from './utils';

const Headline: FC<HeadlineProps> = ({
  description,
  descriptionUI,
  title,
  titleUI,
  titlePlaceholderToReplace,
  titleReplacedValue,
  productsAmount,
}) => (
  <div className="shopping-cart__headline">
    <Typography
      {...titleUI}
      content={setHeadlineTitle(
        title,
        titlePlaceholderToReplace,
        titleReplacedValue,
        productsAmount
      )}
      className="shopping-cart__headline-title"
    />
    {description ? (
      <Typography
        {...descriptionUI}
        content={description}
        className="shopping-cart__headline-description"
      />
    ) : null}
  </div>
);

export default Headline;
